import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@web/molecules';
import { Footer } from '../Footer';
import { useReporter } from '../../reporter';
import {
  userViewsOnboardingInterstitial,
  userContinuesFromInterstitial,
} from '../events';
import {
  StyledOnboardingInterstitial,
  ImageContainer,
  Headline,
  Subheadline,
  Body,
} from './styles.js';

export const OnboardingInterstitial = ({
  goBack,
  onSubmit,
  image,
  headline,
  subheadline,
  body,
  previousQuestion = '',
}) => {
  const reporter = useReporter();
  const viewPageTagFired = useRef(false);
  useEffect(() => {
    if (!viewPageTagFired.current) {
      reporter.tag(userViewsOnboardingInterstitial(previousQuestion));
      viewPageTagFired.current = true;
    }
  }, [reporter, previousQuestion]);
  const handleSubmit = () => {
    reporter.tag(userContinuesFromInterstitial(previousQuestion));
    onSubmit();
  };

  return (
    <>
      <StyledOnboardingInterstitial>
        <ImageContainer>
          <ResponsiveImage
            src={image.src}
            alt={image.alt}
            width={200}
            height={200}
          />
        </ImageContainer>
        <Headline>{headline}</Headline>
        <Subheadline>{subheadline}</Subheadline>
        <Body>{body}</Body>
        <Footer
          onBackButtonClick={goBack}
          onForwardButtonClick={handleSubmit}
        />
      </StyledOnboardingInterstitial>
    </>
  );
};
OnboardingInterstitial.displayName = 'OnboardingInterstitial';
OnboardingInterstitial.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  headline: PropTypes.node,
  subheadline: PropTypes.node,
  body: PropTypes.string,
  goBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  previousQuestion: PropTypes.string,
};
